export const SHOW_ALERT = 'SHOW_ALERT'
export const DISMISS_ALERT = 'DISMISS_ALERT'
